import { ComponentProps, CSSProperties } from 'react';

interface LogoProps extends ComponentProps<'svg'> {
  logoColor?: string;
  withName?: boolean;
  style?: CSSProperties;
  size?: number;
}

export const Logo = ({ withName, style, size = 24, logoColor, ...otherProps }: LogoProps) => {
  if (withName) {
    return (
      <svg
        width={size * 3.4}
        height={size}
        viewBox="0 0 1429 324"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        {...otherProps}
      >
        <path
          d="M1230.6 319.72V94.7759H1264.34V129.867C1272.44 119.07 1282.34 109.922 1294.03 102.424C1305.73 94.9258 1320.73 91.1768 1339.02 91.1768C1354.62 91.1768 1369.17 94.9258 1382.66 102.424C1396.46 109.622 1407.56 120.569 1415.95 135.266C1424.65 149.662 1429 167.508 1429 188.803V319.72H1395.26V189.702C1395.26 169.307 1389.41 152.961 1377.71 140.664C1366.02 128.068 1350.87 121.769 1332.27 121.769C1319.68 121.769 1308.28 124.618 1298.08 130.317C1287.89 136.016 1279.64 144.114 1273.34 154.611C1267.34 164.808 1264.34 176.656 1264.34 190.152V319.72H1230.6Z"
          fill="#04173E"
        />
        <path
          d="M1080.04 323.319C1057.24 323.319 1037.3 318.22 1020.2 308.023C1003.11 297.526 989.76 283.429 980.162 265.733C970.864 248.038 966.216 228.543 966.216 207.248C966.216 185.653 970.714 166.158 979.712 148.762C988.71 131.067 1001.61 117.12 1018.4 106.923C1035.2 96.4254 1054.99 91.1768 1077.79 91.1768C1100.88 91.1768 1120.68 96.4254 1137.17 106.923C1153.97 117.12 1166.87 131.067 1175.86 148.762C1184.86 166.158 1189.36 185.653 1189.36 207.248V220.745H1000.86C1002.66 233.941 1006.86 246.088 1013.45 257.186C1020.35 267.983 1029.5 276.681 1040.9 283.279C1052.29 289.578 1065.49 292.727 1080.49 292.727C1096.38 292.727 1109.73 289.278 1120.53 282.379C1131.32 275.181 1139.72 266.033 1145.72 254.936H1182.61C1174.81 275.031 1162.37 291.527 1145.27 304.424C1128.48 317.021 1106.73 323.319 1080.04 323.319ZM1001.31 189.252H1154.27C1151.27 170.057 1143.17 154.011 1129.98 141.114C1116.78 128.218 1099.38 121.769 1077.79 121.769C1056.19 121.769 1038.8 128.218 1025.6 141.114C1012.7 154.011 1004.61 170.057 1001.31 189.252Z"
          fill="#04173E"
        />
        <path
          d="M861.902 319.72V124.469H823.211V94.776H861.902V74.9809C861.902 50.387 869.25 31.9416 883.946 19.6446C898.942 7.34769 919.337 1.19922 945.131 1.19922H947.83V33.1413H943.331C927.735 33.1413 915.888 36.7404 907.79 43.9386C899.692 50.8369 895.643 62.0841 895.643 77.6802V94.776H947.83V124.469H895.643V319.72H861.902Z"
          fill="#04173E"
        />
        <path
          d="M752.991 56.9865V12.8975H789.432V56.9865H752.991ZM754.341 319.721V94.7772H788.083V319.721H754.341Z"
          fill="#04173E"
        />
        <path d="M662.078 319.72V4.79785H695.82V319.72H662.078Z" fill="#04173E" />
        <path
          d="M318.423 78.1935V0.306641H159.132C159.132 88.438 87.8887 159.878 0 159.878V319.45C79.7411 319.45 152.624 290.009 208.463 241.419V319.45H367.595C367.595 231.318 438.839 159.878 526.727 159.878V0.306641C447.05 0.306641 374.247 29.6837 318.423 78.1935Z"
          fill="#2760CE"
        />
      </svg>
    );
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...otherProps}
    >
      <path
        d="M14.5088 8.16043V4.625H7.25075C7.25075 8.62544 4.00459 11.8682 0 11.8682V19.1115C3.63335 19.1115 6.9542 17.7751 9.49849 15.5695V19.1115H16.7492C16.7492 15.111 19.9954 11.8682 24 11.8682V4.625C20.3695 4.625 17.0523 5.95848 14.5088 8.16043Z"
        fill="#2760CE"
      />
    </svg>
  );
};
